export default "__VITE_ASSET__Do$X5rLW__"